// src/hooks/useKeyboardBack.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useKeyboardBack(toFallback = '/dashboard') {
  const navigate = useNavigate();

  useEffect(() => {
    const onKeyDown = (e) => {
      // Alt + ArrowLeft
      const isAltLeft = e.altKey && e.key === 'ArrowLeft';
      // Backspace وقتی focus روی input یا textarea نیست
      const isBackspace = e.key === 'Backspace' && !isEditableElement(document.activeElement);

      if (isAltLeft || isBackspace) {
        // جلوگیری از رفتار پیش‌فرض در صورت نیاز
        e.preventDefault();
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate(toFallback);
        }
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [navigate, toFallback]);
}

function isEditableElement(el) {
  if (!el) return false;
  const tag = el.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA') return true;
  if (el.isContentEditable) return true;
  // برای عناصر فرم دلخواه که ممکن است focus بشوند
  const role = el.getAttribute && el.getAttribute('role');
  if (role === 'textbox') return true;
  return false;
}
